import { createReducer } from '@reduxjs/toolkit';
import { SET_PROPAGE_FAQS } from '../actions/ProPageAction';

const initialState = {
    proPageFaqs: [],
};

const proPage = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_PROPAGE_FAQS, (state, action) => {
            state.proPageFaqs = action.faqs;
        });
});

export default proPage;
